import { migrateBotProfile } from './migrate.ts';
import type { BotProfileDocument } from './types.ts';
import { CURRENT_BOT_PROFILE_VERSION } from './version.ts';

export function serializeBotProfile(profile: BotProfileDocument): string {
  return `${JSON.stringify({ ...profile, version: CURRENT_BOT_PROFILE_VERSION }, null, 2)}\n`;
}

/** Returns null instead of throwing. The returned document is always the current version. */
export function parseBotProfile(json: string): BotProfileDocument | null {
  try {
    return migrateBotProfile(JSON.parse(json) as unknown);
  } catch {
    return null;
  }
}

export function isBotProfile(value: unknown): boolean {
  return migrateBotProfile(value) !== null;
}

export function cloneBotProfile(profile: BotProfileDocument): BotProfileDocument {
  return { ...profile, dials: profile.dials ? { ...profile.dials } : null, knobs: { ...profile.knobs } };
}
